<div [@loading]="elements.length" *ngIf="!(currentWeatherService.weather$ | async)">
    <div *ngFor="let color of elements" class="circle" [ngStyle]="{'background-color': color}"></div>
</div>
